export default __webpack_public_path__ + "static/media/cadastrar-icon.2485da80.svg";